import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { useState, useEffect } from 'react'

export default function ScrollButton() {
  const [showButton, setShowButton] = useState(false)

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const handleScroll = () => {
    if (window.pageYOffset > 150) {
      setShowButton(true)
    } else {
      setShowButton(false)
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <>
      {showButton && (
        <button
          onClick={scrollToTop}
          className={`fixed bottom-16 sm:bottom-24 right-6 sm:right-12 bg-blue-600 hover:bg-blue-700 rounded-full shadow-xl max-sm:h-10 max-sm:w-10 h-12 w-12 flex flex-row justify-center items-center`}
        >
          <FontAwesomeIcon icon={faArrowUp} size={'lg'} className='text-white' />
        </button>
      )}
    </>
  )
}
